import React from "react";
import InfoDialog from "../../components/InfoDialog.tsx"; 

interface Props {
  open: boolean;
  onClose: () => void;
}

export const ManualBoolInfoDialog: React.FC<Props> = ({ open, onClose }) => (
  <InfoDialog
    open={open}
    onClose={onClose}
    title="Nutzereingabe"
    text={`Mit der Nutzereingabe kann Feedback vom Tester eingeholt werden, welches nicht mit der Prüfelektronik geprüft werden kann. Die Frage sollte immer geschlossen formuliert werden, sodass Tester eindeutig mit "Pass" oder "Fail" antworten können.
        Die Eingabe kann direkt mit den Buttons am Gerät gemacht werden.`
    }
    imageSrc="/testprocedere/ManualBool.png"
  />
);